import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { FaSearchPlus } from 'react-icons/fa';

const Gallery = () => {
  const [filter, setFilter] = useState('all');
  const [selectedImg, setSelectedImg] = useState(null);

  // Gallery Data Updated with your images and categories
  const galleryItems = [
    
    
    // Adam & Eve Day
    { id: 1, category: 'adam & eve day', img: '/Adam & Eve Day _22.jpg' },
    { id: 2, category: 'adam & eve day', img: '/Adam & Eve Day.jpeg' },
    { id: 3, category: 'adam & eve day', img: '/Adam & Eve Day(1).jpeg' },
    { id: 4, category: 'adam & eve day', img: '/Adam & Eve Day(2).jpeg' },
    { id: 5, category: 'adam & eve day', img: '/Adam & Eve Day(3).jpeg' },
    { id: 6, category: 'adam & eve day', img: '/Adam & Eve Day(4).jpeg' },

    // Community Bash
    { id: 7, category: 'community bash', img: '/Community Bash.jpeg' },
    { id: 8, category: 'community bash', img: '/Community Bash (2).jpeg' },
    { id: 9, category: 'community bash', img: '/Community Bash (3).jpeg' },
    { id: 10, category: 'community bash', img: '/Community Bash (4).jpeg' },

    // Eid Milaad Un Nabi
    { id: 11, category: 'eid milad un nabi', img: '/Eid Milaad Un Nabi.jpeg' },
    { id: 12, category: 'eid milad un nabi', img: '/Eid Milaad Un Nabi (2).jpeg' },
    { id: 13, category: 'eid milad un nabi', img: '/Eid Milaad Un Nabi (3).jpeg' },
    { id: 14, category: 'eid milad un nabi', img: '/Eid Milaad Un Nabi (4).jpeg' },

    // Eid Namaz
    { id: 15, category: 'eid namaz', img: '/Eid Namaz.jpeg' },
    { id: 16, category: 'eid namaz', img: '/Eid Namaz(1).jpeg' },
    { id: 17, category: 'eid namaz', img: '/Eid Namaz(2).jpeg' },
    { id: 18, category: 'eid namaz', img: '/Eid Namaz(3).jpeg' },
    { id: 19, category: 'eid namaz', img: '/Eid Namaz(4).jpeg' },
    { id: 20, category: 'eid namaz', img: '/Eid Namaz(5).jpeg' },
    { id: 21, category: 'eid namaz', img: '/Eid Namaz(6).jpeg' },
    { id: 22, category: 'eid namaz', img: '/Eid Namaz(7).jpeg' },
    { id: 23, category: 'eid namaz', img: '/Eid Namaz(8).jpeg' },
    { id: 24, category: 'eid namaz', img: '/Eid Namaz(9).jpeg' },
    { id: 25, category: 'eid namaz', img: '/Eid Namaz(10).jpeg' },
    { id: 26, category: 'eid namaz', img: '/Eid Namaz(11).jpeg' },
    { id: 27, category: 'eid namaz', img: '/Eid Namaz(12).jpeg' },
    { id: 28, category: 'eid namaz', img: '/Eid Namaz(13).jpeg' },

    // Iftaar Dinner
    { id: 29, category: 'iftar dinner', img: '/Iftaar Dinner.jpeg' },
    { id: 30, category: 'iftar dinner', img: '/Iftaar Dinner(1).jpeg' },
    { id: 31, category: 'iftar dinner', img: '/Iftaar Dinner(2).jpeg' },
    { id: 32, category: 'iftar dinner', img: '/Iftaar Dinner(3).jpeg' },

    // Garba event
    { id: 33, category: 'Garba', img: '/Garba.jpeg' },
    { id: 34, category: 'Garba', img: '/Garba(1).jpeg' },
    { id: 35, category: 'Garba', img: '/Garba(2).jpeg' },
    { id: 36, category: 'Garba', img: '/Garba(3).jpeg' },
    { id: 37, category: 'Garba', img: '/Garba(4).jpeg' },
    { id: 38, category: 'Garba', img: '/Garba(5).jpeg' },
    { id: 39, category: 'Garba', img: '/Garba(6).jpeg' },
    { id: 40, category: 'Garba', img: '/Garba(7).jpeg' },
    { id: 41, category: 'Garba', img: '/Garba(8).jpeg' },
    { id: 42, category: 'Garba', img: '/Garba(9).jpeg' },
    { id: 43, category: 'Garba', img: '/Garba(10).jpeg' },
    { id: 44, category: 'Garba', img: '/Garba(11).jpeg' },

  ];

  const filteredItems = filter === 'all' ? galleryItems : galleryItems.filter(i => i.category === filter);

  return (
    <div className="min-h-screen bg-white">
      
      {/* 1. HERO SECTION */}
      <section 
        className="relative h-[45vh] flex items-center justify-center bg-cover bg-center"
        style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/Garba(10).jpeg')` }}
      >
        <div className="text-center text-white">
          <motion.h1 
            initial={{ y: 20, opacity: 0 }} 
            animate={{ y: 0, opacity: 1 }} 
            className="text-5xl md:text-6xl font-serif font-black uppercase tracking-tight"
          >
            Gallery
          </motion.h1>
          <div className="h-1.5 w-20 bg-[#f9b50b] mx-auto mt-4"></div>
          
          <p className="mt-4 uppercase tracking-[0.3em] text-xs font-bold">
            <Link to="/" className="hover:text-[#f9b50b] text-gray-400">Home</Link>
            <span className="mx-2 text-gray-400">/</span>
            <span className="transition-colors">Gallery</span>
          </p>
        </div>
      </section>

      {/* 2. GALLERY FILTER SECTION */}
      <section className="py-24 px-6 max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-serif font-bold uppercase mb-4 text-[#221f1f]">Moments of Impact</h2>
          <p className="text-gray-400 text-xs font-bold uppercase tracking-widest italic">We capture the hope and transformation in every smile</p>
        </div>

        {/* Filter Buttons Updated */}
        <div className="flex flex-wrap justify-center gap-3 mb-16">
          {['all', 'iftar dinner', 'eid namaz', 'adam & eve day', 'eid milad un nabi', 'community bash','Garba'].map((cat) => (
            <button 
              key={cat} 
              onClick={() => setFilter(cat)} 
              className={`px-8 py-3 text-[11px] font-black uppercase tracking-widest border transition-all duration-500 
              ${filter === cat ? 'bg-[#f9b50b] border-[#f9b50b] text-[#221f1f]' : 'bg-white border-gray-200 hover:text-[#f9b50b] hover:border-[#f9b50b]'}`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Image Grid */}
        <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          <AnimatePresence>
            {filteredItems.map((item) => (
              <motion.div 
                key={item.id} 
                layout 
                initial={{ opacity: 0, scale: 0.9 }} 
                animate={{ opacity: 1, scale: 1 }} 
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.4 }}
                className="relative group overflow-hidden cursor-pointer h-80 shadow-lg border-4 border-white"
                onClick={() => setSelectedImg(item.img)}
              >
                <img 
                  src={item.img} 
                  alt={item.category} 
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
                />
                <div className="absolute inset-0 bg-[#f9b50b]/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <div className="text-center">
                    <FaSearchPlus className="text-white text-4xl mx-auto transform scale-0 group-hover:scale-100 transition-transform duration-300" />
                    <p className="text-white font-black uppercase tracking-widest text-[10px] mt-2">View Larger</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </section>

      {/* Lightbox / Zoom Modal */}
      <AnimatePresence>
        {selectedImg && (
          <motion.div 
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[1000] bg-black/95 flex items-center justify-center p-4 md:p-10 cursor-zoom-out" 
            onClick={() => setSelectedImg(null)}
          >
            <motion.div initial={{ scale: 0.5 }} animate={{ scale: 1 }} exit={{ scale: 0.5 }} className="relative max-w-5xl w-full">
              <img src={selectedImg} className="w-full h-auto max-h-[85vh] object-contain border-4 border-white shadow-2xl" alt="Enlarged" />
              <button className="absolute -top-12 right-0 text-white text-4xl hover:text-[#f9b50b]" onClick={() => setSelectedImg(null)}>&times;</button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

    </div>
  );
};

export default Gallery;